
import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";

function WarrantyReport({ branchID }) {

  const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const reportOptions = [
    { value: 'machine_under_warranty', label: 'Machine Under Warrranty' },
    { value: 'warranty_claim', label: 'Warrranty Claim' },


  ]

  const fetchBranchDetail = async () => {
    try {
      const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
      setBranchDetail(resInventory.data)

    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    fetchBranchDetail();

  }, []);


  const handleSearch = async (e) => {
    e.preventDefault();

    if (!fromDate || !toDate) {
      setToast('Please select both From Date and To Date', 'warning');
      return;
    }

    try {
      const params = {
        noteType: noteType?.value,
        from_date: fromDate,
        to_date: toDate,
      };

      const result = await axios.get(
        'https://api.skyguard.group/api/get-warranty-report',
        { params }
      );

      const resultData = result?.data?.result || [];


      if (noteType?.value === 'warranty_claim') {
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);

        const filteredData = resultData
          .map(row => {
            let visits = [];

            try {
              visits = Array.isArray(row.visits)
                ? row.visits
                : JSON.parse(row.visits || '[]');
            } catch {
              visits = [];
            }

            const filteredVisits = visits.filter(v => {
              if (!v.visitDate) return false;

              const visitDateObj = new Date(v.visitDate);
              if (isNaN(visitDateObj.getTime())) return false;

              return visitDateObj >= fromDateObj && visitDateObj <= toDateObj;
            });

            return { ...row, visits: filteredVisits };
          })
          .filter(row => row.visits.length > 0);

        setfetchData(filteredData);

        if (filteredData.length > 0) {
          setToast('Warranty claim report fetched successfully', 'success');
        } else {
          setToast('No warranty claim data found in selected date range', 'warning');
        }
        return;
      }

      if (noteType?.value === 'machine_under_warranty') {
        setfetchData(resultData);

        if (resultData.length > 0) {
          setToast('Machine under warranty report fetched successfully', 'success');
        } else {
          setToast('No warranty data found in selected date range', 'warning');
        }
        return;
      }

      setfetchData(resultData);

      if (resultData.length > 0) {
        setToast('Report fetched successfully', 'success');
      } else {
        setToast('No data found in selected date range', 'warning');
      }

    } catch (error) {
      console.error('❌ Error fetching report:', error);
      setToast('Error fetching report. Please try again.', 'danger');
    }
  };

  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

     const handleExportExcel = () => {
        const table = document.getElementById("exportTable");
      
        if (!table) return;
      
        const worksheet = XLSX.utils.table_to_sheet(table);
        const workbook = XLSX.utils.book_new();
      
        XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
      
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
      
        const data = new Blob([excelBuffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
      
        saveAs(data, "Warrnty_Report.xlsx");
      };


            const handlePrint = () => {
  const content = document.getElementById("exportTable");

  if (!content) return;

  const printWindow = window.open("", "", "width=900,height=700");

  // printWindow.document.write(`
  //   <html>
  //     <head>
  //       <title>AMC Report</title>
  //       <style>
  //         body {
  //           font-family: Arial, sans-serif;
  //           padding: 20px;
  //         }
  //         table {
  //           width: 100%;
  //           border-collapse: collapse;
  //         }
  //         table, th, td {
  //           border: 1px solid black;
  //         }
  //         th, td {
  //           padding: 8px;
  //           text-align: left;
  //         }
  //       </style>
  //     </head>
  //     <body>
  //       ${content.outerHTML}
  //     </body>
  //   </html>
  // `);


  printWindow.document.write(`
  <html>
    <head>
      <title>AMC Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 10px;
          margin: 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
          word-wrap: break-word;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 12px;
        }

        /* Prevent overflow */
        div {
          overflow: visible !important;
        }

        /* Fit content inside page */
        @page {
          size: A4 landscape;
          margin: 10mm;
        }
      </style>
    </head>
    <body>
      ${content.outerHTML}
    </body>
  </html>
`);
  printWindow.document.close();
  printWindow.focus();

  // Wait for content to load, then print
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};


  return (
    <>

      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

          <h3 className='my-3 fw-bold fs-5 golos'>Report</h3>


          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
              {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
               <FaSearch size={26} className="ms-1 text-primary"
                                            style={{ cursor: "pointer" }}
                                            title="Search"
                                            onClick={handleSearch}
                                             
                                          />
                            
                                          <MdLocalPrintshop
                                            size={26}
                                            className="ms-2 text-success"
                                              //  onClick={handleExportExcel}
                                               onClick={handlePrint}
                                            style={{ cursor: "pointer" }}
                                            title="Print "
                                          />
            </div>
          </div>

          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                  <h4 className="text-center mb-3 fw-bold">
    {noteType?.label || "Warranty Report"}
  </h4>


            {noteType?.value === 'machine_under_warranty' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Doc No</th>
                    <th>Party Name</th>
                    <th>Start Date</th>
                    <th>Party Contact</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{`WTY/${item.id}/${branchDetail.code}`}</td>
                        <td>{item.party_name}</td>
                        <td>{formatDateTime(item.start_date)}</td>
                        <td>
                          {[item.party_phone, item.party_mobile, item.phone_two, item.phone_three]
                            .filter(v => v && v.trim() !== "")
                            .join(", ")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {noteType?.value === 'warranty_claim' && (
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Customer Name</th>
                    <th>Machine Name</th>
                    <th> Sr No.</th>

                    <th>Service Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.flatMap((row, rowIdx) => {


                      let itemsArr = [];
                      try {
                        itemsArr = typeof row.items === 'string'
                          ? JSON.parse(row.items)
                          : row.items || [];
                      } catch {
                        itemsArr = [];
                      }

                      const visitsArr = Array.isArray(row.visits) ? row.visits : [];


                      if (visitsArr.length === 0) {
                        return itemsArr.map((it, itIdx) => {
                          const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';

                          return (
                            <tr key={`${rowIdx}-${itIdx}-novisit`}>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                              <td>{srNo}</td>
                              <td>-</td>
                            </tr>
                          );
                        });
                      }

                      return itemsArr.flatMap((it, itIdx) => {
                        const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';

                        return visitsArr.map((v, vIdx) => {
                          const visitDate = v.visitDate
                            ? new Date(v.visitDate).toLocaleString()
                            : '-';

                          return (
                            <tr key={`${rowIdx}-${itIdx}-${vIdx}`}>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                              <td>{srNo}</td>
                              <td>{visitDate}</td>
                            </tr>
                          );
                        });
                      });
                    })
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}

                </tbody>
              </table>
            )}


          </div>


        </div>
      </div>
    </>
  )
}

export default WarrantyReport